module.exports = __webpack_public_path__ + "img/Kanata.c9ee6be5.jpg";